import { useEffect, useState } from "react";
import EditProfileblm from "../../SearchHome/EditProfileblm";
// import { Colorcontext } from "../../Component/Colorcontext/ColorContext";
import Blmpostadd from "../../SearchHome/Blmpostadd";
import Viewersengagement from "../../SearchHome/Viewersengagement";
import Upgradeprofile from "../../SearchHome/Upgradeprofile";
import Contactdetaiilsprofile from "../../SearchHome/Contactdetaiilsprofile";
import Uploadbannerblm from "../../SearchHome/Uploadbannerblm";
import Aboutusblmprofile from "../../SearchHome/Aboutusblmprofile";
import Servicesblmprofile from "../../SearchHome/Servicesblmprofile";
import Socilallinkprofile from "../../SearchHome/Socilallinkprofile";
import Galleryblmprofile from "../../SearchHome/Galleryblmprofile";
// import Workprogressbar from "../../SearchHome/Workprogressbar";
import Searchkeywordprofile from "../../SearchHome/Searchkeywordprofile";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOwnProfile } from "../../../Redux/Slice/PostSlice";
import HttpClient from "../../../utils/HttpClient";
// import toast from "react-hot-toast";
// import BlmEnquiry from "../../SearchHome/BlmEnquiry";
import { fetchPageEnquiries, fetchPostEnquiries } from "../../../Redux/Slice/EnquirySlice";
import { fetchAllBusinessPosts } from "../../../Redux/Slice/BusinessPostSlice";
// import PageUnderAdminReview from "../../SearchHome/PageUnderReview";
import BusinessListingEnquiry from "../components/BusinessListingEnquiry";

const UpdateBusinessPage = ({ onNext, onBack }) => {
  const params = useParams();
  // const location = useLocation();
  const dispatch = useDispatch();
  const { UserProfileID } = useSelector((state) => state.app);
  const { PageEnquiries, PostEnquiries } = useSelector((state) => state.enquiry);
  // const { choosePlanID, subscriptionId } = location?.state || {};
  const [UserMemberData, setUserMemberData] = useState({});
  const [data, setData] = useState();
  const [formData, setFormData] = useState();
  const [isUpdate, setIsUpdate] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setData(UserProfileID);
  }, [UserProfileID, params]);

  useEffect(() => {
    if (UserProfileID) {
      dispatch(fetchPageEnquiries())
      dispatch(fetchPostEnquiries())
      dispatch(fetchAllBusinessPosts())
    }
  }, [])

  useEffect(() => {
    if (isUpdate) {
      updateData(data)
      setIsUpdate(false)
    }
  }, [isUpdate])

  useEffect(() => {
    data?._id !== UserProfileID?._id && data?._id && handlePageVisit(data?._id)
  }, [data?._id])

  const updateData = async (data) => {
    const updatedBusinessData = {
      ...data,
    };

    // Remove properties
    delete updatedBusinessData._id;
    delete updatedBusinessData.password;
    delete updatedBusinessData.token;
    delete updatedBusinessData.SLNo;
    delete updatedBusinessData.TypeOfCompany;
    delete updatedBusinessData.avgRating;
    delete updatedBusinessData.designation;
    delete updatedBusinessData.doc;
    delete updatedBusinessData.likeCount;
    delete updatedBusinessData.likes;
    delete updatedBusinessData.loginStatus;
    delete updatedBusinessData.memberStatus;
    delete updatedBusinessData.partnerStatus;
    delete updatedBusinessData.passwordView;
    delete updatedBusinessData.productData;
    delete updatedBusinessData.rating;
    delete updatedBusinessData.referralStatus;
    delete updatedBusinessData.service;
    delete updatedBusinessData.serviceID;
    delete updatedBusinessData.serviceName;
    delete updatedBusinessData.upgradeStatus;
    delete updatedBusinessData.activationCode;
    delete updatedBusinessData.companyDescription;
    delete updatedBusinessData.companyTypeName;
    delete updatedBusinessData.dribbbleLink;
    delete updatedBusinessData.gender;
    // delete updatedBusinessData.phone_code;
    delete updatedBusinessData.qrCode;
    delete updatedBusinessData.rewardPoints;
    delete updatedBusinessData.updatedOn;
    delete updatedBusinessData.userLink;
    delete updatedBusinessData.userName;
    delete updatedBusinessData.userType;
    delete updatedBusinessData.userTypeName;
    delete updatedBusinessData.videoUrl;
    delete updatedBusinessData.walletPoints;
    delete updatedBusinessData.websiteLink;
    // delete updatedBusinessData.whats_code;
    delete updatedBusinessData.youtubeLink;

    try {
      const response = await HttpClient.requestData(`update-business/${UserProfileID?._id}`, "PUT", updatedBusinessData);
      if (response?.status) {
        dispatch(getOwnProfile())
        setIsLoading(false)
      } else {
        console.error("Error from listing business");
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      setIsLoading(false)
    } finally {
    }
  }

  const updateForm = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  const handlePageVisit = async (id) => {
    try {
      await HttpClient.requestData(`business-page-visit`, "POST", { userId: id });
    } catch (error) {
      console.error("error:", error);
    }
  }

  return (
    <>
      {
        isLoading ? "Saving..." :
          (
            <>
              <section className="wizrd-item-section">
                <div className="wizrd-item-container">
                  <div className=" reposivecideforspecial">
                    <div className="ownblmprofiledivleft">
                      <div className="repsonsivedivcls">
                        {/* For Tablet responsive code start  */}
                        <div className=" oenblmsnfidivmainleft">
                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                            <EditProfileblm updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                          </div>

                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                            <Contactdetaiilsprofile
                              setData={setData}
                              data={data}
                              updateForm={updateForm}
                              setIsUpdate={setIsUpdate}
                            />
                          </div>
                        </div>
                        <div className="oenblmsnfidivmainright">
                          {
                            UserProfileID?._id === data?._id &&
                            <div className="oenblmsnfdrpbapbbtm responsivdedivmain ">
                              <Blmpostadd />
                            </div>
                          }

                          {
                            UserProfileID?._id === data?._id &&
                            <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                              <Viewersengagement />
                            </div>
                          }

                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain ">
                            {UserProfileID?._id === data?._id && <Upgradeprofile />}
                          </div>
                          <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                            <Uploadbannerblm data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                          </div>
                        </div>
                        {/* For Tablet responsive code  end */}
                      </div>

                      <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                        <EditProfileblm updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                      </div>

                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                          <Blmpostadd />
                        </div>
                      }

                      {
                        UserProfileID?._id !== data?._id ?
                          <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                            <BusinessListingEnquiry />
                          </div>
                          :
                          <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">

                            <div className='bmlmmaposttaddddib'>
                              <div className='bmlmmaposttaddddibdivmain'>
                                <div className='poisyybtnmainlibkldivflx'>

                                  {/* <Link className="_direxrrcttstbtn ipyysffraedtn"
                                    style={{
                                      margin: "0 auto",
                                      color: "#fff"
                                    }}
                                    to="/myenquiries"
                                    disabled={!UserProfileID?.businessStatus}
                                  >
                                    View Enquiries ({PageEnquiries?.length + PostEnquiries?.length})
                                  </Link> */}

                                  <Link className="_direxrrcttstbtn ipyysffraedtn"
                                    style={{
                                      margin: "0 auto",
                                      color: "#fff",
                                      pointerEvents: !UserProfileID?.businessStatus ? "none" : "auto",
                                      opacity: !UserProfileID?.businessStatus ? 0.5 : 1
                                    }}
                                    to="/myenquiries"
                                  >
                                    View Enquiries ({PageEnquiries?.length + PostEnquiries?.length})
                                  </Link>

                                </div>
                              </div>
                            </div>

                          </div>
                      }



                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                          <Viewersengagement />
                        </div>
                      }

                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                          <Upgradeprofile />
                        </div>
                      }

                      <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                        <Contactdetaiilsprofile
                          setData={setData}
                          data={data}
                          updateForm={updateForm}
                          setIsUpdate={setIsUpdate}
                        />
                      </div>

                    </div>
                    <div className="ownblmprofiledivright">
                      <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                        <Uploadbannerblm data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                      </div>
                      <div className="oenblmsnfdrpbapbbtm">
                        <Aboutusblmprofile data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                      </div>

                      <div className="oenblmsnfdrpbapbbtm">
                        <Servicesblmprofile
                          data={data}
                          updateForm={updateForm}
                          setData={setData}
                          setIsUpdate={setIsUpdate}
                        />
                      </div>

                      {
                        UserProfileID?._id === data?._id &&
                        <div className="oenblmsnfdrpbapbbtm">
                          <Searchkeywordprofile data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                        </div>
                      }


                      <div className="oenblmsnfdrpbapbbtm">
                        <Galleryblmprofile
                          setData={setData}
                          data={data}
                          updateForm={updateForm}
                          setIsUpdate={setIsUpdate}
                        />
                      </div>
                      <div className="oenblmsnfdrpbapbbtm">
                        <Socilallinkprofile updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />

                        <div className="box-border-gr d-flex justify-content-center align-items-center bg-white p-3 mt-2">
                          <button className="btn btn-secondary mr-2" onClick={onBack}>
                            Back
                          </button>
                          <button className="btn btn-success" onClick={onNext}>
                            Pay Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Screen Design Start */}

                  <div className="mobilereposiveprofile">
                    <div className="bannerprofileblmreposnive">
                      <Uploadbannerblm data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                    </div>
                    <div className="mobilereposvispsicaldivflx">
                      <div className={UserProfileID?._id === data?._id ? "eidteprofileblmreposnive" : 'eidteprofileblmreposnive2'}>
                        <EditProfileblm updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                      </div>



                      <div className="viewsprofileprofileblmreposnive">
                        {UserProfileID?._id === data?._id &&
                          <div className="bklmlposprofileprofileblmreposnive">
                            <Blmpostadd />
                          </div>
                        }

                        {
                          UserProfileID?._id === data?._id ?
                            <div className="_bklmlposprofileprofileblmreposnive">
                              <div className="oenblmsnfdrpbapbbtm _deslrtopwdijjsmain">

                                <div className='bmlmmaposttaddddib'>
                                  <div className='bmlmmaposttaddddibdivmain'>
                                    <div className='poisyybtnmainlibkldivflx'>

                                      <Link className="direxrrcttstbtn ipyysffraedtn"
                                        style={{
                                          margin: "0 auto",
                                          color: "#fff"
                                        }}
                                        to="/myenquiries"
                                      >

                                        View Enquiries({PageEnquiries?.length + PostEnquiries?.length})
                                      </Link>

                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                            :
                            <div className="_bklmlposprofileprofileblmreposnive">
                              <BusinessListingEnquiry />
                            </div>
                        }

                        {UserProfileID?._id === data?._id &&
                          <div className="bklmlposprofileprofileblmreposnive">
                            <Viewersengagement />
                          </div>
                        }

                        {UserProfileID?._id === data?._id &&
                          <div className="">
                            <Upgradeprofile />
                          </div>
                        }

                      </div>
                    </div>

                    <div className="contaallprofileblmreposnive">
                      <Contactdetaiilsprofile
                        setData={setData}
                        data={data}
                        updateForm={updateForm}
                        setIsUpdate={setIsUpdate}
                      />
                    </div>
                    <div className="contaallprofileblmreposnive">
                      <Aboutusblmprofile data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                    </div>
                    <div className="contaallprofileblmreposnive">
                      <Servicesblmprofile
                        data={data}
                        updateForm={updateForm}
                        setData={setData}
                        setIsUpdate={setIsUpdate}
                      />
                    </div>

                    {
                      UserProfileID?._id === data?._id &&
                      <div className="oenblmsnfdrpbapbbtm">
                        <Searchkeywordprofile data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                      </div>
                    }

                    <div className="contaallprofileblmreposnive">
                      <Galleryblmprofile
                        setData={setData}
                        data={data}
                        updateForm={updateForm}
                        setIsUpdate={setIsUpdate}
                      />
                    </div>
                    <div className="contaallprofileblmreposnive">
                      <Socilallinkprofile updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />

                      <div className="box-border-gr d-flex justify-content-center align-items-center bg-white p-3 mt-2">
                        <button className="btn btn-secondary mr-2" onClick={onBack}>
                          Back
                        </button>
                        <button className="btn btn-success" onClick={onNext}>
                          Pay Now
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Screen Design End */}
                </div>
                {/* <div className="box-border-gr d-flex justify-content-center align-items-center bg-white p-3 mt-2">
                  <button className="btn btn-secondary mr-2" onClick={onBack}>
                    Back
                  </button>
                  <button className="btn btn-success" onClick={onNext}>
                    Pay Now1
                  </button>
                </div> */}
              </section>
            </>
          )
      }
    </>

  );
};

export default UpdateBusinessPage;
